'use client';
import PaginatedGrid, { GridType } from '@components/PaginatedGrid';
import axios from 'axios';
import PlaylistContext from './_PlaylistContext';
import GridItem from './_GridItem';

import type { PlaylistItem } from '@repo/ui/src/types/youtubeLink';

interface TraegerTvData {
  hits: Array<PlaylistItem>;
  nbPages: number;
  nbHits: number;
  page: number;
  locale: string;
}

interface TraegerTvCategoryBodyClientBoundaryProps {
  category: string;
  _data: TraegerTvData;
}

const TraegerTvCategoryBodyClientBoundary = ({
  category,
  _data,
}: TraegerTvCategoryBodyClientBoundaryProps) => {
  const loadData = async ({ page }: { page: number }, controller: AbortController) => {
    return await axios.get('/api/traeger-tv/getTraegerTvListItems', {
      params: {
        category,
        page,
        pageSize: 10,
        lang: _data.locale,
      },
      signal: controller.signal,
    });
  };

  return (
    <PlaylistContext.Provider value={_data?.hits}>
      <PaginatedGrid
        _data={_data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.TraegerTv}
        darkBackground
        disableBorder
      />
    </PlaylistContext.Provider>
  );
};

export default TraegerTvCategoryBodyClientBoundary;
